import React from 'react';
import { Flower2, Droplets, Sprout } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { features } from '../mock';
import { AdSenseBillboard } from './AdComponents';


const iconMap = {
  'Flower2': Flower2,
  'Droplets': Droplets,
  'Sprout': Sprout
};

export const FeatureGrid = () => {
  return (
    <section id="features" className="py-16 lg:py-24 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-4xl mx-auto mb-12">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-serif font-bold text-gray-900 mb-4">
            Pourquoi l'Apiculture Urbaine ?
          </h2>
          <p className="text-lg text-gray-600">
            Découvrez les bénéfices concrets de l'apiculture sur balcon et rejoignez 
            le mouvement des apiculteurs urbains engagés.
          </p>
        </div>

        {/* Feature Cards */}
        <div className="grid md:grid-cols-3 gap-8">
          {features.map((feature, index) => {
            const IconComponent = iconMap[feature.icon];
            return (
              <Card 
                key={index} 
                className="group hover:shadow-xl transition-all duration-300 border-2 hover:border-honey"
              >
                <CardContent className="p-8 text-center">
                  <div className="w-16 h-16 mx-auto mb-6 rounded-full bg-sage/10 flex items-center justify-center group-hover:bg-honey/10 transition-colors">
                    <IconComponent className="h-8 w-8 text-sage group-hover:text-honey transition-colors" />
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-3">
                    {feature.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {feature.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* In-Content Ad Placeholder */}
        <div className="mt-16">
          {/* Billboard Ad Space - Google AdSense */}
          <div className="mt-12">
            <AdSenseBillboard 
              adClient="ca-pub-8650202956587648"
              adSlot="7553574737"
            />
          </div>
        </div>
      </div>
    </section>
  );
};
